export default __webpack_public_path__ + "static/media/logo-tfex.08dec1e9.svg";